export default {
  en: {
    general: {
      now: 'NOW',
      currently: 'Currently ',
      current: 'Current and Upcoming',
      more: 'More',
      noResults: 'No results...',
      notFound: '404 Not Found',
      share: 'Share',
      back: 'Back',
      home: 'Home',
      program: 'Program',
      learningAndExperience: 'Learning & Experience',
      books: 'Books',
      news: 'News',
      next: 'Next',
      prev: 'Prev',
      openings: 'Tue-Sun 10:30-18:30',
      open: 'Open',
      closed: 'Closed',
      close: 'Close',
      tacb: 'Times Art Center Berlin',
      supportUs: 'Support Us',
      relatedContent: 'Related Content',
      copyURL: 'Copy URL',
      copied: 'Copied',
      purchase: 'Purchase',
      soldOut: 'Sold Out',
      mediaAndResources: 'Media & Resources',
      fullscreen: 'Fullscreen'
    },
    filters: {
      all: 'All',
      assemblies: 'Assemblies',
      exhibition: 'Exhibition',
      types: 'Types',
      years: 'Years',
      allYears: 'By Year',
      allAssemblies: 'By Assembly',
      allTypes: 'By Type',
      rmFilters: 'Remove filters ×'
    },
    pubs: {
      issue: 'Issue',
      issueNo: 'Issue #',
      issueNoSuffix: '',
      less: 'Read less'
    },
    prog: {
      more: 'Read more...',
      hasAudio: 'Unmute',
      related: 'Related'
    },
    search: {
      search: 'Search',
      busy: 'Searching...',
      noResults: 'Nothing found'
    },
    footer: {
      tel: 'TEL: +8620-26272363',
      fax: 'FAX: +8620-26270660',
      backToTop: 'Back to Top',
      copy: '© GUANDONG TIMES MUSEUM.',
      more: 'More',
      about: 'About',
      rights: 'All rights reserved'
    },
    slider: {
      books: 'Books Books',
      supportUs: 'Support Us',
      tacb: 'Berlin Times Art Center',
      store: 'Store Times'
    },
    types: {
      entity: 'Person/Institution',
      contribution: 'Contribution',
      news: 'News',
      program: 'Program'
    }
  },
  cn: {
    general: {
      now: '首页',
      currently: '目前',
      current: '现在和未来项目',
      more: '更多',
      noResults: 'No results...',
      notFound: '404 找不到页面',
      share: '分享',
      back: '返回',
      home: '首页',
      program: '项目',
      learningAndExperience: '学习和体验',
      books: '出版物',
      news: '新闻',
      next: '下一条',
      prev: '上一条',
      openings: '周二至周日 10:30-18:30',
      open: '开馆',
      closed: '闭馆',
      supportUs: '支持我们',
      close: '收起',
      tacb: '时代艺术中心（柏林）',
      relatedContent: '相关内容',
      copyURL: '复制链接',
      copied: '已复制',
      purchase: '购买',
      soldOut: '售罄',
      mediaAndResources: '资源下载',
      fullscreen: '全屏'
    },
    filters: {
      all: '全部',
      assemblies: '系列',
      exhibition: '展览',
      types: '分类',
      years: '年份',
      allYears: '全部 年份',
      allAssemblies: '全部 系列',
      allTypes: '全部 分类',
      rmFilters: 'Remove filters ×'
    },
    pubs: {
      issue: 'Issue',
      issueNo: '第',
      issueNoSuffix: '期',
      less: '收起'
    },
    prog: {
      more: '阅读更多',
      hasAudio: 'This contribution incorporates audio. Please click to allow',
      related: '相关项目'
    },
    search: {
      search: '搜索',
      busy: '搜索中......',
      noResults: '无结果'
    },
    footer: {
      tel: 'TEL: +8620-26272363',
      fax: 'FAX: +8620-26270660',
      backToTop: '回到上面',
      copy: '© 广东时代美术馆，版权所有',
      more: '更多',
      about: '关于',
      rights: ''
    },
    slider: {
      books: '出版物 出版物',
      supportUs: '支持我们 支持我们',
      tacb: '时代艺术中心 （柏林）',
      store: '商品店'
    },
    types: {
      entity: '人名/机构',
      contribution: '稿件',
      news: '新闻',
      program: '项目'
    }
  }
}
